import data from "./types/data";
import meta from "./types/meta";
import query from "./types/query";

const initialState = {
    data,
    query,
    meta
};

const featuredProductsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'featuredProducts/update':
            return {
                ...state,
                ...action.payload
            };

        case 'featuredProducts/clear':
            return initialState;

        default:
            return state;
    }
};

export default featuredProductsReducer;